import { useLang } from "../../i18n/LanguageContext";

export const Capabilities = () => {
  const { t } = useLang();

  return (
    <section
      id="capabilities"
      data-testid="capabilities-section"
      className="relative py-16 lg:py-20 border-t border-white/5 bg-[#0A0E17]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16">
          <div className="lg:col-span-5">
            <div className="inline-flex items-center gap-2 text-[#00E5FF] font-mono text-xs uppercase tracking-[0.24em]">
              <span className="w-6 h-px bg-[#00E5FF]" />
              {t.capabilities.eyebrow}
            </div>
            <h2
              data-testid="capabilities-title"
              className="mt-5 font-heading font-bold text-white text-3xl sm:text-4xl lg:text-5xl leading-[1.1] tracking-tight"
            >
              {t.capabilities.title}
            </h2>
            <p className="mt-6 text-slate-300 text-base leading-relaxed">
              {t.capabilities.subtitle}
            </p>
          </div>

          <div className="lg:col-span-7">
            <ul className="flex flex-wrap gap-2.5">
              {t.capabilities.tags.map((tag, i) => (
                <li
                  key={i}
                  data-testid={`capability-tag-${i}`}
                  className="group inline-flex items-center gap-2 border border-white/10 bg-white/[0.03] hover:border-[#00E5FF]/40 hover:bg-[#00E5FF]/5 transition-colors duration-300 px-3.5 py-2 rounded-full"
                >
                  <span className="w-1.5 h-1.5 rounded-full bg-[#00E5FF]/60 group-hover:bg-[#00E5FF] transition-colors duration-300" />
                  <span className="font-mono text-[11px] sm:text-xs tracking-wide text-slate-200 uppercase">
                    {tag}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Capabilities;
